<template>
  <div class="faixa-comparacao" v-if="selectedCount">
    <span class="text-lg">
      {{
        selectedCount === 1
          ? 'Selecione ao menos 2 dados para comparação'
          : `${selectedCount} dados selecionados`
      }}
    </span>
    <router-link
      v-if="selectedCount > 1"
      title="Comparar Dados"
      class="btn btn-default"
      :to="{
        name: 'public_comparar',
        params: { ids: idsArray.join(',') }, 
        query: { origem: query }     
      }"
    >
      Comparar {{ selectedCount }} dados
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    idsArray: {
      type: Array
    },
    query: {
      type: String
    }
  },
  computed: {
    selectedCount() {
      return this.idsArray.length
    }
  }
}
</script>

<style scoped>
.faixa-comparacao {
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: fixed;
  z-index: 9;
  bottom: 0;
  background-color: #266c16;
  height: 70px;
  width: 100%;
}

.faixa-comparacao > span {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Dados/FaixaComparacao.vue